// 具体交互参考 antd，需要使用两个 日期 + 时间选择
import React, { useEffect, useState, useRef } from 'react'
import { Calendar } from 'react-date-range'
import styled from '@emotion/styled'
import { Button } from '@mantine/core'
import { dayjsInit } from '@ow/utils'
import TimeList from './time-list'
import { StyledTimeSelect, StyledButton } from '../styled'

const SELECTED_DATE_COLOR = '#fff'
const END_DATE = '#3c4d62'
const StyledCalendar = styled(Calendar)`
  padding: 10px;
  direction: ltr;
  border-right: 1px solid #dbdfea;
  box-shadow: none;
  width: 270px;
  color: #526484;
  background: #fff;
  .rdrMonthAndYearWrapper,
  .rdrWeekDays {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-weight: 800;
    font-size: 12px;
  }
  .rdrWeekDay {
    width: 34px;
    height: 30px;
    padding: 4px;
  }
  .rdrDay {
    position: relative;
  }
  .rdrDays {
    display: flex;
    flex-wrap: wrap;
    .rdrDayNumber {
      padding: 4px;
      display: block;
      text-align: center;
      width: 35px;
      border-radius: 4px;
      height: 30px;
      color: #526484;
      position: absolute;
      left: 0;
      top: 0;
      line-height: 22px;
    }
    button {
      outline: none;
      background: #fff;
      border: none;
      padding: 0;
      width: 35px;
      height: 30px;
      margin: 0;
      > span:hover {
        background: #ebeef2;
        cursor: pointer;
        line-height: 22px;
      }
      span.rdrSelected,
      span.rdrSelected:hover {
        background: var(--ow-color-primary-600);
      }
      span.rdrSelected + span,
      span.rdrSelected + span:hover,
      span.rdrSelected + span + span,
      span.rdrSelected + span + span:hover {
        background: var(--ow-color-primary-600);
        color: #fff;
      }
    }
    .rdrDayPassive .rdrDayNumber {
      color: #dbdfea;
    }
  }
  .rdrDayToday {
    .rdrDayNumber {
      border: 1px solid var(--ow-color-primary-600);
      border-radius: 4px;
    }
  }
  .rdrDayDisabled {
    background-color: rgb(248, 248, 248);
    span.rdrDayNumber,
    span.rdrDayNumber:hover {
      cursor: not-allowed;
      background-color: rgb(248, 248, 248);
      span {
        color: #aeb9bf;
      }
    }
  }
  .rdrNextPrevButton {
    display: block;
    width: 24px;
    height: 24px;
    margin: 0 0.833em;
    padding: 0;
    border: 0;
    border-radius: 4px;
    background: #fff;
    &:hover {
      background: #ebeef2;
      cursor: pointer;
    }
    i {
      display: block;
      width: 0;
      height: 0;
      padding: 0;
      text-align: center;
      border-style: solid;
      margin: auto;
      transform: translate(-3px, 0px);
    }
  }

  .rdrPprevButton {
    i {
      border-width: 4px 6px 4px 4px;
      border-color: transparent rgb(52, 73, 94) transparent transparent;
      transform: translate(-3px, 0px);
    }
  }

  .rdrNextButton {
    i {
      margin: 0 0 0 7px;
      border-width: 4px 4px 4px 6px;
      border-color: transparent transparent transparent rgb(52, 73, 94);
      transform: translate(3px, 0px);
    }
  }
  .rdrMonthAndYearPickers {
    display: flex;
    font-weight: 600;
    select {
      appearance: none;
      -webkit-appearance: none;
      border: 0;
      background: transparent;
      padding: 10px 30px 10px 10px;
      border-radius: 4px;
      outline: 0;
      color: #3e484f;
      background-position: right 8px center;
      cursor: pointer;
      text-align: center;
    }
  }
  .rdrMonthPicker {
    option {
      -webkit-appearance: none;
      background: #fff;
      cursor: pointer;
    }
  }

  .rdrSelected,
  .rdrInRange,
  .rdrStartEdge,
  .rdrEndEdge {
    width: 35px;
    height: 30px;
    background: var(--ow-color-primary-600);
    position: absolute;
    top: 0px;
    left: 0;
    right: 0;
    bottom: 5px;
    border-radius: 4px;
  }

  .rdSelected + span {
    color: #fff;
  }

  .rdrStartEdge {
    border-radius: 4px;
    background: ${({ startDateBackground }) => {
      return startDateBackground || 'var(--ow-color-primary-600)'
    }};
  }
  .rdrEndEdge {
    border-radius: 4px;
    background: ${({ endDateBackground }) => {
      return endDateBackground || END_DATE
    }};
  }

  .rdrDay:not(.rdrDayPassive) .rdrStartEdge ~ .rdrDayNumber span,
  .rdrDay:not(.rdrDayPassive) .rdrEndEdge ~ .rdrDayNumber span {
    color: ${({ selectedDateColor }) => {
      return selectedDateColor || SELECTED_DATE_COLOR
    }};
  }
  .rdrDateDisplay {
    display: none;
  }
`
const StyledCalendarWrapper = styled('div')`
  display: flex;
  border-bottom: 1px solid #dbdfea;
`

const formatDate = (time) => {
  return dayjsInit(time).format('YYYY-MM-DD')
}

const PickerWithTime = (props) => {
  const { style, onChnage, disabledDayFn, ...otherProps } = props
  const [startDate, setStartDate] = useState('')
  const [startTime, setStartTime] = useState('00:00')
  const [endDate, setEndDate] = useState('')
  const [endTime, setEndTime] = useState('23:59')
  const [selectTime, setSelectTime] = useState('00:00')
  const [hour, setHour] = useState('00')
  const [min, setMin] = useState('00')
  const [startEditing, setStartEditing] = useState(true)
  const [btnDisabled, setBtnDisabled] = useState(true)
  const [date, setDate] = useState(null)
  const hourRef = useRef(null)
  const minRef = useRef(null)

  const onChangeDate = (selectDate) => {
    setDate(selectDate)
    if (startEditing) {
      setStartDate(selectDate)
    } else {
      setEndDate(selectDate)
    }
  }

  const onSelectTimeItem = ({ type, val }) => {
    const timeArr = selectTime.split(':')
    timeArr[type === 'hour' ? 0 : 1] = val
    const time = timeArr.join(':')
    setSelectTime(time)
    if (startEditing) {
      setStartTime(time)
    } else {
      setEndTime(time)
    }
  }

  const onConfirm = () => {
    if (startEditing) {
      // 设置小时
      setStartEditing(false)
      setSelectTime('23:59')
      hourRef.current.reset()
      minRef.current.reset()
      setDate(null)
    } else {
      let start = new Date(`${formatDate(startDate)} ${startTime}:00.000`)
      let end = new Date(`${formatDate(endDate)} ${endTime}:59.999`)
      if (start > end) {
        ;[start, end] = [end, start]
      }
      const time = {
        selection: {
          key: 'selection',
          startDate: start,
          endDate: end,
        },
      }
      onChnage(time)
    }
  }

  const disabledDay = (displayDate) => {
    if (startEditing) return false
    return displayDate < startDate
  }
  // 控制 button disabled 状态
  useEffect(() => {
    setBtnDisabled(
      startEditing ? !startDate || !startTime : !endDate || !endTime
    )
  }, [startDate, startTime, endDate, endTime, startEditing])

  useEffect(() => {
    const timeArr = selectTime.split(':')
    setHour(timeArr[0])
    setMin(timeArr[1])
  }, [selectTime])

  return (
    <>
      <StyledCalendarWrapper>
        <StyledCalendar
          style={style}
          date={date}
          onChange={onChangeDate}
          dateDisplayFormat="YYYY-MM-DD"
          {...otherProps}
          disabledDay={disabledDay}
        />
        <StyledTimeSelect>
          <div className="timeResult">{selectTime}</div>
          <div className="list">
            <TimeList
              ref={hourRef}
              defaultVal={hour}
              onSelectTimeItem={onSelectTimeItem}
            />
            <TimeList
              ref={minRef}
              defaultVal={min}
              type="minute"
              onSelectTimeItem={onSelectTimeItem}
            />
          </div>
        </StyledTimeSelect>
      </StyledCalendarWrapper>
      <StyledButton>
        <Button onClick={() => onConfirm()} disabled={btnDisabled}>
          确定
        </Button>
      </StyledButton>
    </>
  )
}
export default PickerWithTime
